import { useGT } from "gt-react";

import type { QueryRiskLevel } from "../persistence";

export const QUERY_RISK_OPTIONS: Array<{ value: QueryRiskLevel; label: string; note: string }> = [
  { value: "harmless", label: "Harmless", note: "Safe for routine reads and repeatable discovery." },
  { value: "normal", label: "Normal", note: "Agent should be sure what it is doing before execution." },
  { value: "dangerous", label: "Dangerous", note: "Agent should ask the user before execution." },
];

export function QueryRiskBar(props: {
  remarks: string;
  riskLevel: QueryRiskLevel;
  isProduction: boolean;
  onRemarksChange: (value: string) => void;
  onRiskLevelChange: (value: QueryRiskLevel) => void;
}) {
  const { remarks, riskLevel, isProduction, onRemarksChange, onRiskLevelChange } = props;
  const t = useGT();
  const activeRisk = QUERY_RISK_OPTIONS.find((option) => option.value === riskLevel) ?? QUERY_RISK_OPTIONS[1]!;

  return (
    <div className={`query-risk-bar query-risk-bar--${riskLevel}`}>
      <div className="flex min-w-0 flex-1 items-center gap-2">
        {isProduction && (
          <span className="query-risk-bar__env">
            {t("Production")}
          </span>
        )}
        <input
          value={remarks}
          onChange={(event) => onRemarksChange(event.target.value)}
          placeholder={t("Add short agent guidance or operator notes")}
          className="query-risk-bar__remarks"
        />
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <span className="text-[10px] font-medium uppercase tracking-[0.24em] text-zinc-500">
          {t("Risk level")}
        </span>
        <select
          value={riskLevel}
          onChange={(event) => onRiskLevelChange(event.target.value as QueryRiskLevel)}
          className="query-risk-bar__badge"
          aria-label={t("Risk level")}
          title={activeRisk.note}
        >
          {QUERY_RISK_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
